'use client';
import type { StoryOverview } from '~/common/types/story-overview';
import { EpisodeItem } from '@app/(default-layout)/se/[seriesId]/_components/episode-item/episode-item';
import { EpisodeItemOuter } from '@app/(default-layout)/se/[seriesId]/_components/episode-item/episode-item-outer';
import { css } from '@styled-system/css';
import { Box } from '@styled-system/jsx';
import { AdContainer } from './ad-container';
import { useLocalHooks } from './use-local-hooks';
import { showAd } from './utils/show-ad-util';

export type StoryListWithVipOnlyModalProps = {
  seriesId: string;
  stories: StoryOverview[];
  canShowGoogleAd: boolean;
};

export const StoryListWithVipOnlyModal = ({
  seriesId,
  stories,
  canShowGoogleAd,
}: StoryListWithVipOnlyModalProps) => {
  const { showVipOnlyModal, userIsVip } = useLocalHooks();

  return (
    <>
      {stories?.map((story, index) => {
        return story.isVipOnly && !userIsVip ? (
          <EpisodeItemOuter
            onClick={(e) => showVipOnlyModal(e, story.id)}
            key={`${seriesId}-${story.id}-${index}`}
          >
            <EpisodeItem key={story.id} story={story} disableLink />
            {showAd(index) && (
              <li>
                <AdContainer
                  listIndex={index}
                  isLastAd={false}
                  canShowGoogleAd={canShowGoogleAd}
                />
              </li>
            )}
          </EpisodeItemOuter>
        ) : (
          <Box
            key={`${seriesId}-${story.id}-${index}`}
            className={css({
              borderBottom: '1px solid #d7d8da',
              _lastOfType: {
                borderBottom: 'none',
                _hover: {
                  borderBottom: 'none',
                },
              },
              _hover: {
                borderBottom:
                  '1px solid transparent' /* 非表示になるとガタガタするから透明に */,
              },
            })}
          >
            <EpisodeItem key={story.id} story={story} />
            {showAd(index) && (
              <li>
                <AdContainer
                  listIndex={index}
                  isLastAd={false}
                  canShowGoogleAd={canShowGoogleAd}
                />
              </li>
            )}
          </Box>
        );
      })}
    </>
  );
};
